import { SETTOKEN, GETSELECTEDORDER, GETORDERS, SETERROR, SETORDERCOUNT, LOGOUT, GETORDERHISTORY, SETISLOADING, SETDEVICETOKEN } from "../actionTypes";

const initialState = {
    token: localStorage.getItem("token") ? localStorage.getItem("token") : false,
    orders: [],
    selectedOrder: {},
    error: "",
    currentOrderCount: 0,
    previousOrderCount: 0,
    orderHistory: [],
    isLoading: false,
    deviceToken: ""
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SETTOKEN:
            {
                return {
                    ...state,
                    token: action.payload
                }
            }

        case GETSELECTEDORDER: {
            return {
                ...state,
                selectedOrder: action.payload,
                isLoading: false,
            }
        }

        case GETORDERS: {
            return {
                ...state,
                orders: action.payload,
                isLoading: false,
            }
        }
        case SETERROR: {
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            }
        }

        case SETORDERCOUNT: {
            return {
                ...state,
                currentOrderCount: action.payload.currentOrders,
                previousOrderCount: action.payload.previousOrders

            }
        }
        case LOGOUT: {
            return {
                ...state,
                ...initialState,
                token: ""
            }
        }
        case GETORDERHISTORY: {
            return {
                ...state,
                orderHistory: action.payload
            }
        }
        case SETISLOADING: {
            return {
                ...state,
                isLoading: true
            }
        }
        case SETDEVICETOKEN: {
            return {
                ...state,
                deviceToken: action.payload
            }
        }
        default:
            return state;
    }
}



const orderStatus = [{ id: 1, status: "pending", text: "" }];




